export const AUTH_TOKEN = 'auth_token';
export const PATH = 'path';
export const ANONYMOUS_ID = 'anonymous_id';
export const SEAMLESS_LOGIN = 'SeamlessLogin';
export const DEVICE_ID = 'device_id';

export const ITINERARY_ID_TRACK_EVENT = 'ITINERARY_ID';
